import SceButton from '../../../../../../../../Common/CommonComponents/sceButton.js';
import SceTextBoxComponent from '../../../../../../../../Common/TextBox/sceText.js';
import classes from './editTextDialogBox.scss';
import { getLocalizedStrings } from './popUpCommonStrings';
import RadioGroup from '../../../../../../../../Common/CommonComponents/radioButton.js';
import Modal from 'react-awesome-modal';
/***********************
Change type : Security changes for phone numbers
Changed by: Sai Aman Pothuganti
Date : 06-10-2020
************************/
import GlobalErrorBlock from '../../../../../../../../Common/CommonComponents/GlobalErrorBlock/globalErrorBlock';
import ErrorStrings from '../../../errorStrings';

const EditTextDialogBox = (props) => {
  const strings = getLocalizedStrings('addEmailDialog');
  // var EditTextNumber = props.deleteValue;
  // var [, , lastFourDigit] = EditTextNumber.split('-');
  const loadingSpinner = props.showSpinner ? <div className={classes.sceRightIcon}>
  <i className='fa fa-spinner fa-spin' /></div> : null ;
  return (
  <div className={classes.scrollDiv}>
    <Modal
      visible='true'
      effect="fadeInUp"
      width="100%"
      height="100%">
    <div className={classes.sceAddEmailDialog}>
      <div className={'row ' + classes.sceAddEmailDialogWrap}>
        <div className={'col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 ' + classes.sceAddEmailDialogMain}>
          <div className={classes.sceCancelDialogSection}>
            {props.isLocalError ? <GlobalErrorBlock errorMessage={ErrorStrings["DEFAULT"]} /> : null}
            <div className={classes.sceCancelDialogInfo}>
              <div className={classes.sceDialogMainContent}>{strings.editTextHeading}</div>
              <div className={classes.sceDialogNote}>{strings.editTextNote}</div>
              {/* <div className={classes.sceEditNumber}>{app.appUtil.maskPhoneNumberWithhyphenX(app.appUtil.formatPhoneNumber(props.deleteValue))}</div> */}
              <div className={classes.sceTextBoxData}>
                <SceTextBoxComponent 
                  id='editTextMessageNum' type='cppResPhone' maxLength={13} 
                  placeholder={props.deleteValue}  
                  validator={app.appUtil.validator} 
                  //defaultValue={app.appUtil.formatPhoneNumber(props.deleteValue)}
                  onTextUpdatedHandler={props.retrievedataFromTextBoxes} 
                  isError={props.editTextMessageNum.isError}
                  isValid={props.editTextMessageNum.isValid}
                  errorMsg={props.editTextMessageNum.errorMsg}
                  value={props.editTextMessageNum.value}
                /> 
                {loadingSpinner}
              </div>
              <div className={classes.sceRadio}>
                {props.options.map((email, i) => {
                  return (
                    <div key={'radio' + i}>
                      <RadioGroup
                        setName={'editTextRadioOptions'}
                        options={[props.options[i]]}
                        type='radio'
                        validStyle={props.selectedOptionValidStyle}
                        radioOutLineFlag={props.radioOutline}
                        selectedOptions={props.selectedOptions}
                        onClick={(event) => props.onMobileRadioClick(event, i)}
                      // onFocus={(event) => props.onRadioFocus(event, i)}
                      />  
                    </div>
                  );
                })
                }
              </div>



            </div>
            <div className={'row ' + classes.sceCancelDialogActions}>
              <div className={'col-xs-12 col-sm-6 col-sm-push-6 ' + classes.sceConfirmBtn}>


                <SceButton
                  id='cancelDialogYes'
                  buttonType={props.editTextMessageNum.value==="" || props.editTextMessageNum.isError || props.selectedOptions === '' || props.isLocalError || props.showSpinner ? 'default' : 'sceSmPrimary'}
                  value={strings.btnConfirm}
                  responive='false'
                  isDisabled={props.selectedOptions === ''}
                  onClick={props.editTextMessageNum.value==="" || props.selectedOptions === '' || props.isLocalError || props.showSpinner ? (e)=>e.preventDefault() : props.onEditTextMessageConfirmDialogClick}
                />

              </div>

              <div className={'col-xs-12 col-sm-6 col-sm-pull-6 ' + classes.sceCancelBtn}>

                <SceButton
                  id='cancelDialogNo'
                  buttonType='sceClose'
                  value={<span id={'cancelDialogno'}>{strings.btnCancel}</span>}
                  responive='false'
                  onClick={(e) => props.onCancelClickHandler(e)}
                  iconType='cancel'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </Modal>
  </div>

  );
};
export default EditTextDialogBox;